uniform vec3 uDepthColor;
uniform vec3 uSurfaceColor;
uniform float uColorOffset;
uniform float uColorMultiplier;

varying float vElevation;
varying vec3 vNormal;
varying vec3 vPosition;

#include ../includes/pointLight.glsl
#include ../includes/ambientLight.glsl

void main()
{
    vec3 viewDirection = normalize(vPosition - cameraPosition);
    vec3 normal = normalize(vNormal);

    // Base color - yaxshilangan
    float mixStrength = (vElevation + uColorOffset) * uColorMultiplier;
    mixStrength = smoothstep(0.0, 1.0, mixStrength);
    vec3 color = mix(uDepthColor, uSurfaceColor, mixStrength);

    // Light
    vec3 light = vec3(0.0);

    // Ambient light - asosiy yorug'lik
    light += ambientLight(
        vec3(1.0, 0.95, 0.9),  // Warm white
        0.3
    );

    // Main point light - markazda
    light += pointLight(
        vec3(1.0, 0.8, 0.6),     // Warm orange tint
        15.0,                    // Intensity
        normal,
        vec3(0.0, 0.5, 0.0),    // Position (above center)
        viewDirection,
        30.0,                    // Specular power
        vPosition,
        0.5                      // Decay
    );

    // Secondary light - yon tomonda
    light += pointLight(
        vec3(0.4, 0.6, 1.0),     // Cool blue
        8.0,
        normal,
        vec3(1.5, 0.3, -1.0),
        viewDirection,
        20.0,
        vPosition,
        0.6
    );

    // Rim light effect - chekkalarni yorug' qilish
    float rimLight = 1.0 - max(0.0, dot(viewDirection, -normal));
    rimLight = pow(rimLight, 3.0);
    light += vec3(1.0, 0.5, 0.3) * rimLight * 0.4;

    color *= light;

    // Fresnel effect - chetlarda yorug'roq
    float fresnel = pow(1.0 - max(0.0, dot(-viewDirection, normal)), 2.0);
    color += uSurfaceColor * fresnel * 0.15;

    // Final color
    gl_FragColor = vec4(color, 1.0);
    #include <tonemapping_fragment>
    #include <colorspace_fragment>
}
